import React from 'react';
import ReactDOM from 'react-dom';
import './fonts/Heebo-Regular.ttf'
import './index.css';
import App from './App';
import { registerAppServiceWorker } from './Helper/swRegistration';

import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-big-calendar/lib/css/react-big-calendar.css'
import 'antd/dist/antd.css'; // or 'antd/dist/antd.less'

import { Provider } from "react-redux";
import store from "./redux/store/index";
ReactDOM.render(<Provider store={store}><App /></Provider>, document.getElementById('root'));


// Single combined service worker (firebase-messaging-sw.js) — handles both
// FCM push and PWA offline caching, registered at scope "/".
//
// DO NOT also call CRA's serviceWorker.unregister() here. Its implementation
// does `navigator.serviceWorker.ready.then(reg => reg.unregister())`, which
// on returning users (with no stale CRA worker left to find) resolves with
// OUR firebase-messaging-sw.js and silently kills it on every page load —
// causing FCM to mint a fresh push subscription each refresh and the DB to
// accumulate one new push_subscription row per reload.
//
// Selective cleanup of legacy CRA `service-worker.js` registrations is done
// inside registerAppServiceWorker via purgeStaleCRAWorkers(), which matches
// the filename specifically and never touches the Firebase SW.
registerAppServiceWorker();
